import tw, { styled } from "twin.macro";

export const StyledQrDescription = styled.div(({ theme }) => [
  tw`flex items-center justify-center flex-col text-white w-[93.938rem]`,
  `font-family: ${theme.fontFamily.primary};`,
]);

export const Description = tw.div` font-normal text-[4rem] leading-[4.92rem] text-center mt-[3.313rem]`;
